export function roundUpToHundreds(value) {
    return Math.ceil(value / 100) * 100;
}

export function formatCurrency(value) {
    if (typeof value !== "number") return value;
    return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
}